<template>
    <div v-loading="dataLoading">
        <el-form :model="formData" ref="formData" label-position="top" size="medium">
            <el-card v-for="(item, index) in formData.data" :key="index" class="MB20">
                <div slot="header" class="card-header">
                    <div>分类{{ index + 1 }}</div>
                    <el-button v-if="formData.data.length > 1" size="mini" type="primary" plain
                        @click="handleDeleteGroup(index)">删除</el-button>
                </div>
                <el-form-item :prop="`data[${index}].photo`" label="标题图片:">
                    <!-- <image-upload :url.sync="item.photo" :urlFull.sync="item.photo" ref="posterUpload"
                        class="poster-upload">
                    </image-upload> -->
					<el-button icon="el-icon-plus"  style="width:100%"   @click="addpic(index)" type="success" plain>新增图片</el-button>
					<el-table :data="item.photoList" border style="width: 100%" size="small" row-key="id" stripe
					    class="MT10">					    
					    <el-table-column  label="图片">
							<template slot-scope="scope">
								<el-image v-if="scope.row.photo" :src="scope.row.photo | coverImage(80,80)" fit="cover" :preview-src-list="[scope.row.photo]"></el-image>
							</template>
						</el-table-column>
					    <el-table-column prop="link" label="图片跳转链接"></el-table-column>
					    <el-table-column fixed="right" label="操作" width="80">
					        <template slot-scope="scope">
					            <el-button type="text" size="mini" @click="delPic(index,scope.$index)">删除</el-button>
					        </template>
					    </el-table-column>
					</el-table>
                </el-form-item>
                <el-form-item :prop="`data[${index}].activityList`" label="绑定演出:">
                    <div class="search-bar">
                        <el-input placeholder="输入演出ID，多个ID用英文逗号分隔" class="input-with-select" v-model="item.shearchValue">
                            <el-button slot="append" icon="el-icon-search" @click="searchActivity(index)">添加演出</el-button>
                        </el-input>
                    </div>
                    <el-table :data="item.activityList" border style="width: 100%" size="small" row-key="id" stripe
                        class="MT10" :class="`sortable-${index}`" >
                        <el-table-column label="排序" width="48" class-name="sort-handle">
                            <span class="el-icon-sort"></span>
                        </el-table-column>
                        <el-table-column prop="id" label="演出ID" width="100"></el-table-column>
                        <el-table-column prop="name" label="演出名称" show-overflow-tooltip></el-table-column>
                        <el-table-column fixed="right" label="操作" width="80">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" @click="handleDeleteActivity(index,scope.$index)">解绑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-card>
        </el-form>
        <el-button v-if="formData.data.length < 10" icon="el-icon-plus" class="add-group" style="width:100%" @click="addGroup()">添加分类</el-button>
        <div class="MT30">
            <el-button @click="goBack()">返回列表</el-button>
            <el-button @click="goStep1()">上一步</el-button>
            <el-button v-if="$utils.have('/operational/theme/bindActivity')" type="primary" @click="onSubmit"
                :loading="btnLoading">保存</el-button>
        </div>
		<!-- <UploadPic ref="uploadPic" @updateImg="updateImg"></UploadPic> -->
		<el-drawer
		    title="上传标题图片"
		    :visible.sync="drawerShow"
		    :wrapperClosable="false"
		    :destroy-on-close="true"
		    size="auto"			
		    @close="close"
		>
		    <div class="drawer-content" v-loading="dataLoading">
		        <el-form
		            :model="formDatas"               
		            ref="formDatas"
					:rules="rules"
		            label-position="top"
		            size="medium"
		        >               
		            <el-form-item prop="photo" label="上传图片:">
		                <image-upload 
		                    :url.sync="formDatas.photo" 
		                    :urlFull.sync="formDatas.photo"
		    				
		                >
		                </image-upload>
		            </el-form-item>
		            <el-form-item prop="link" label="图片跳转链接:">
		                <el-input v-model="formDatas.link" placeholder="支持运营主题活动、分享活动、膨胀红包活动、幸运抽奖" size="medium"></el-input>
		            </el-form-item>
		        </el-form>
		    </div>
		    <div class="drawer-footer">
		        <el-button @click="close">取消</el-button>
		        <el-button type="primary" @click="uploadpicForm()" :loading="uploadLoading"
		            >确认</el-button
		        >
		    </div>
		</el-drawer>
    </div>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
import Sortable from "sortablejs";
const defaultFormData = {
    data: [{
        activityList: [],
		photoList:[],
        
    }],
}
const defaultData = {
    photo: "",
	link:'',
	
}
export default {
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },
    components: { ImageUpload},
    data() {
        return {
            dataLoading: false,
			uploadLoading:false,
            formData: {
                ...defaultFormData
            },
			formDatas:{
			    ...defaultData
			},
			rules: {
			    photo: [{ required: true, message: "请先上传图片" }],			    
			},
            btnLoading: false,
            redirect: this.$route.query.redirect,
			drawerShow:false,
			index:''
        }
    },
    mounted() {
        if (this.id) {
            this.getDataDetail();
        }
    },
    methods: {
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.push({
                    path: '/operation/special/list',
                });
            }
        },
        goStep1(){
            this.$router.replace({
                path: '/operation/special/edit/step1/'+this.id
            });
        },
		close(){		    
		    this.drawerShow = false;
			this.uploadLoading = false;
			this.$refs.formDatas.resetFields();
		},
		addpic(index){
			
			if( this.formData.data[index].photoList && this.formData.data[index].photoList.length > 100 ){
				return this.$message.warning("最多只能添加100张图片");
			}
			this.drawerShow = true
			this.index = index
			
		},
		//上传图片表单提交
		uploadpicForm() {
			this.formData.data[this.index].photoList = this.formData.data[this.index].photoList ? this.formData.data[this.index].photoList : [];
		    this.$refs["formDatas"].validate((valid) => {
		        if (valid) {		            
					this.uploadLoading = true
					
					 this.formData.data[this.index].photoList.push({
						 link:this.formDatas.link,
						 photo:this.formDatas.photo						 
					 })
					 this.close()
		        }				
		    });
		},
		//删除图片
		delPic(groupIndex, index) {
		    this.formData.data[groupIndex].photoList.splice(index, 1);
		},
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/operational/theme/categoryActivityList",
                params: { id: parseInt(this.id)},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                       this.formData.data = result ? [...result] : [],
					   
						
						console.log(this.formData.data)
						
                        this.drag();
                    } else {
                        this.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //添加分类
        addGroup() {
            this.formData.data.push({
                activityList: [],
                photoList: []
            })
        },
        //删除分类
        handleDeleteGroup(index) {
            this.formData.data.splice(index, 1);
        },
        //删除演出
        handleDeleteActivity(groupIndex, index) {
            this.formData.data[groupIndex].activityList.splice(index, 1);
        },
        drag(){
            this.$nextTick(() => {
                this.formData.data.forEach((item,index) => {
                    const el = document.querySelectorAll('.sortable-'+index+'> .el-table__body-wrapper > table > tbody')[0];
                    Sortable.create(el, {
                        disabled: false, // 拖拽不可用? false 启用
                        ghostClass: 'sortable-ghost', //拖拽样式
                        animation: 150, // 拖拽延时，效果更好看
                        handle: ".sort-handle",
                        onEnd: (e) => { // 拖拽结束时的触发
                            let arr = [...item.activityList]; // 获取表数据
							
                            arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                            
                            this.$nextTick(function () {
                                this.formData.data[index].activityList = [...arr];
                            })
                        },
                    });
                })
            })
        },
        //搜索演出
		searchActivity(index) {
			this.formData.data[index].activityList = this.formData.data[index].activityList ? this.formData.data[index].activityList : [];
			
            let _value = this.formData.data[index].shearchValue;
			
		    if (_value) {
				
		        _value = _value.replace(/，/g, ',');
		
		        let _sActivityIds = _value.split(',');
		        _sActivityIds.map((v, i) => _sActivityIds[i] = parseInt(v));
				
				
				this.$request({
				    url: "/activity/activityIdNameList",
				    method: 'post',
				    data: _sActivityIds
				})
				    .then((res) => {
				        const { state, msg, result } = res.data;
				        if ( state && result && result.length > 0) {
				            result.map(item => {
								
				                if (!this.formData.data[index].activityList.find(v => v.id == item.id)) {
				                    this.formData.data[index].activityList.push(item)
				                }
								
								this.$set(this.formData.data, index, {...this.formData.data[index],activityList: this.formData.data[index].activityList})
								// this.$set(this.formData.data[index], 'activityList', _arr)
								// this.$forceUpdate()
								
				            })
							
				        } else {
				            this.$message.error(msg || '没有找到相关演出');
				        }
				    })
				    
			}
		},
        //表单提交
        onSubmit(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: "/operational/theme/bindActivity",
                        method: "POST",
                        data: {
                            ...this.formData,
                            id: this.id
                        },
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state) {
                                this.goBack()
                            } else {
                                return this.$message.error(msg || "操作失败");								
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.add-group {
    border-style: dashed;
}
.add-pics{
	border-style: dashed;
}
</style>